<template>
  <div class="flex items-center justify-center min-h-screen bg-white">
    <div class="w-full max-w-md p-8 bg-white rounded-xl shadow-lg">
      <h2 class="text-3xl font-semibold text-center text-gray-700 mb-6">Login</h2>

      <div class="space-y-4">
        <input type="email" v-model="email" placeholder="Email"
          class="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" />
        <input type="password" v-model="password" placeholder="Password"
          class="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" />

        <button @click="login" :disabled="isLoading"
          class="w-full px-4 py-3 mt-4 font-semibold text-white bg-blue-600 rounded-lg hover:bg-blue-700 flex items-center justify-center">
          <span v-if="!isLoading">Login</span>
          <div v-else class="loader"></div>
        </button>
      </div>

      <!-- Privacy Policy Link -->
      <div class="mt-6 text-center space-y-2">
        <router-link to="/privacy-policy" class="text-sm text-blue-600 hover:text-blue-800 underline block">
          Privacy Policy
        </router-link>
        <a
          href="/download/si-mamat.apk"
          download
          class="inline-block mt-2 px-4 py-2 bg-green-600 text-white rounded-lg font-semibold hover:bg-green-700 transition"
        >
          Download APK SI MAMAT
        </a>
      </div>
    </div>

    <!-- Toast Notification -->
    <div v-if="isToastVisible"
      class="fixed top-5 right-5 flex items-center w-full max-w-xs p-4 text-gray-500 bg-white rounded-lg shadow-lg dark:text-gray-400 dark:bg-gray-800"
      role="alert">
      <div
        class="inline-flex items-center justify-center w-8 h-8 text-red-500 bg-red-100 rounded-lg dark:bg-red-800 dark:text-red-200">
        <svg class="w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
          viewBox="0 0 20 20">
          <path
            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 11.793a1 1 0 1 1-1.414 1.414L10 11.414l-2.293 2.293a1 1 0 0 1-1.414-1.414L8.586 10 6.293 7.707a1 1 0 0 1 1.414-1.414L10 8.586l2.293-2.293a1 1 0 0 1 1.414 1.414L11.414 10l2.293 2.293Z" />
        </svg>
      </div>
      <div class="ms-3 text-sm font-normal">{{ toastMessage }}</div>
      <button @click="isToastVisible = false" type="button"
        class="ms-auto -mx-1.5 -my-1.5 bg-white text-gray-400 hover:text-gray-900 rounded-lg focus:ring-2 focus:ring-gray-300 p-1.5 hover:bg-gray-100">
        <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
import { auth, db } from "@/firebase";
import { signInWithEmailAndPassword, signOut } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";

export default {
  data() {
    return {
      email: "",
      password: "",
      isLoading: false,
      isToastVisible: false,
      toastMessage: "",
    };
  },
  methods: {
    async login() {
      this.isLoading = true;
      try {
        const userCredential = await signInWithEmailAndPassword(auth, this.email, this.password);
        const user = userCredential.user;

        const userDoc = await getDoc(doc(db, "users", user.uid));

        if (userDoc.exists()) {
          const userData = userDoc.data();
          if (userData.role === "admin") {
            this.$router.push("/dashboard");
          } else {
            await signOut(auth);
            this.showToast("Anda tidak mempunyai akses untuk login");
          }
        } else {
          this.showToast("User tidak ditemukan di database");
        }
      } catch (error) {
        this.showToast(error.message);
      } finally {
        this.isLoading = false;
      }
    },
    showToast(message) {
      this.toastMessage = message;
      this.isToastVisible = true;
      setTimeout(() => {
        this.isToastVisible = false;
      }, 3000);
    },
  },
};
</script>

<style scoped>
.loader {
  width: 24px;
  height: 24px;
  border: 3px solid #ffffff;
  border-radius: 50%;
  border-top-color: transparent;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>
